export default "__VITE_ASSET__DIZNAJh1__"